import { render, staticRenderFns } from "./cHierarchyTreeNodeHorizontal.vue?vue&type=template&id=2b48341a&scoped=true"
import script from "./cHierarchyTreeNodeHorizontal.vue?vue&type=script&lang=js"
export * from "./cHierarchyTreeNodeHorizontal.vue?vue&type=script&lang=js"
import style0 from "./cHierarchyTreeNodeHorizontal.vue?vue&type=style&index=0&id=2b48341a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48341a",
  null
  
)

export default component.exports